import React, { useState, FC } from 'react'
import { format } from 'date-fns'
import { Notification } from '@creditas/icons'

import { ActionLink } from './ActionLink'
import { CallButton } from './CallButton'
import { MessageWrapper } from './MessageWrapper'

type Callback = () => void

interface Props {
  scheduling: Date
  id: string
  name: string
  onCall: (id: string, onStart: Callback, onFinish: Callback) => void
}

const Message: FC<Props> = ({ scheduling, id, name, onCall }) => {
  const [state, setState] = useState('wait')
  const [clicked, setClicked] = useState(false)
  const onStart = (): void => setState('started')
  const onFinish = (): void => setState('finished')

  const call = (): void => {
    onCall(id, onStart, onFinish)
    setClicked(true)
    setTimeout(() => {
      setClicked(false)
    }, 10000)
  }

  return (
    <MessageWrapper>
      <div>
        <p>
          <strong>Lembrete de agendamento</strong>
        </p>
        <ActionLink href={`/auto-refi/${id}/linha-do-tempo`}>{name}</ActionLink>
        <p>{format(scheduling, 'HH:mm')}</p>
      </div>
      <div data-tesid={`call-action-state-${state}`}>
        <CallButton
          onClick={call}
          clicked={clicked}
          testid="scheduling-notification-call-action"
        >
          <Notification.Phone fontSize="large" color="#3377bb" />
        </CallButton>
      </div>
    </MessageWrapper>
  )
}

export { Message }
